import React from 'react'
import Slider from 'react-animated-slider'
import 'react-animated-slider/build/horizontal.css'
import Loading from './loading'
import { connect } from 'react-redux'
import { fetchArticles } from '../../store/actions/articles'

class AnimatedArticleBanner extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            articles: undefined,
        }
    }

    componentDidMount() {
        this.props.fetchArticles()
    }

    componentDidUpdate(prevProps) {
        if (this.props.articles !== prevProps.articles) {
            if (this.props.articles.length === 2) {
                // slider breaks if there are exactly 2 items, so we make it 4
                const articles = []
                this.props.articles.map((a) => articles.push(a))
                this.props.articles.map((a) => articles.push(a))
                this.setState({ articles: articles })
            } else {
                this.setState({ articles: this.props.articles })
            }
        }
    }

    render() {
        if (!this.state.articles) {
            return <Loading />
        }

        if (!this.state.articles.length === 0) return <></>

        function renderArticle(article) {
            return (
                    <div
                        key={article._id}
                        className="slider-content"
                        style={{
                            background: `url('${article.image_url}') no-repeat center center`,
                        }}>
                        <div className="inner">
                            <h1
                                style={{
                                    backgroundColor: 'var(--primary-light)',
                                    color: 'white',
                                }}
                                className="m-2 p-1">
                                {article.title}
                            </h1>

                            <p
                                style={{
                                    backgroundColor: 'var(--secondary-light)',
                                    color: 'white',
                                }}
                                className="m-2 p-1">
                                {article.description}
                            </p>

                            <a
                                href={article.url}
                                target="_blank"
                                rel="noopener noreferrer">
                                <button className="btn btn-secondary">
                                    {article.button_text}
                                </button>
                            </a>

                        </div>

                    </div>
            )
        }

        return (
            <div>
                <h6 className="text-secondary text-center mt-2 mb-4">
                    Here are some resources to help you get started:
                </h6>

                <Slider
                    className="slider-wrapper"
                    duration={2000}
                    infinite={true}
                    autoplay={3000}>
                    {this.state.articles.map((a) => renderArticle(a))}
                </Slider>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    articles: state.articles.articleList,
})

export default connect(mapStateToProps, { fetchArticles })(
    AnimatedArticleBanner
)
